/* global Sentry, Pikaday, moment, google, IBAN */

var DKMS = window.DKMS || {};

DKMS.Utils = {
    topOfFirstError: function() {
        try {
            return $('.parsley-error:visible:first').parent().offset().top;
        } catch (e) {
            return 0;
        }
    },

    escapeHtml: function(str) {
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    },

    loadScript: function(id, src, onload) {
        var existingScript = document.getElementById(id);

        if (!existingScript) {
            var scriptTag = document.createElement('script');
            scriptTag.src = src;
            scriptTag.id = id;
            scriptTag.async = true;
            scriptTag.defer = true;
            document.body.appendChild(scriptTag);

            scriptTag.onload = function() {
                if (onload) {
                    onload();
                }
            };
        }

        if (existingScript && onload) {
            onload();
        }
    }
};

window.gReCaptchaOnLoadCallback = function() {
    $('input[name=dataprotectionprivacy]').on('change', function(e) {
        var captchaContainer = $('.g-recaptcha'),
            siteKey = captchaContainer.attr('data-sitekey'),
            checked = $(this).is(':checked')
        ;

        if (checked) {
            try {
                grecaptcha.render(captchaContainer.get(0), {
                    'sitekey': siteKey
                });
            } catch (ex) {
                console.error(ex);
            }
        }
    }).trigger('change');
};

DKMS.Main = (function(){
    function ucfirst() {
        var $this = $(this);
        try {
            var v = $this.val().toLowerCase(),
                parts = v.split(/\s+/),
                newval = [];

            if (!v.length || this.mangled == true) {
                return;
            }

            $(parts).each(function(_idx, s) {
                if (!s.match(/^(van|von|zu|de)$/)) {
                    s = s[0].toUpperCase() + s.substring(1);
                }

                newval.push(s);
            });

            $this.val(newval.join(' '));
            this.mangled = true; // only change once and let the user decide
        } catch(e) {
            //
        }
    }

    var f = function(){
        var searchWrap = $('header .form-item-search-block-form'),
            searchLabel = searchWrap.find('label').text(),
            searchInput = searchWrap.find('input');
        searchInput.attr('placeholder', searchLabel);

        $('html').removeClass('no-js');

        $('input[type=email]').on('blur', function () {
            var $this = $(this);
            $this.val($this.val().toLowerCase());
        });

        $('.country-PL .phone input').on('blur', function () {
            var $this = $(this);
            $this.val($this.val().replace(/^0/, ''));
        });

        $('.country-PL .street input').on('change', function () {
            var $this = $(this);
            $this.val($this.val().replace(/^ul\.\s?/i, ''));
        });

        // convert non-compliant attr inputmode from data-inputmode
        $('[data-inputmode]').attr('inputmode', function() {
            return $(this).attr('data-inputmode');
        });

        var mainForm = $('main > form');

        if(mainForm.length === 0){
            // exception for moneydonation
            mainForm = $('.tabs-content form');
        }

        mainForm.attr('novalidate', 'novalidate');

        $('main form input').on('blur', function () {
            try {
                $(this).parsley().validate();
            } catch (e) {
                // console.error(e)
            }
        });

        $('.ucfirst').on('blur', ucfirst);

        $('[id^="id_ancestry_label"]').on('change', function(){
            var $this = $(this);
            $this.parent('.fieldwrapper:first').next().toggleClass('open');
        });

        $('[data-info-layer]').each(function () {
            var $this = $(this),
                label = $this.parents('.fieldwrapper').find('> label'),
                infoMessage = $([
                    '<div class="infoMessage">',
                    $this.data('info-layer'),
                    '</div>'
                ].join(''));

            if (label.find('.infoMessage').length > 0) {
                return;
            }
            
            label.append(infoMessage);
            label.addClass('hasInfoMessage');
            var height = infoMessage.height();
            infoMessage.height(height).css('top', -(height+15) + 'px');
        });

        // infolayer for touch devices
        $('.touchevents [data-info-layer]').prev().on('click', function () {
            $(this).find('.infoMessage').toggle();
        });

        window.Parsley.on('form:validate', function () {
            var addressFieldId = 'id_address',
                addressField = $('#' + addressFieldId);

            addressField.parents('.row:first').find('li.fieldwrapper').not('.address').removeClass('hidden');
            addressField.parent().addClass('hidden');
            addressField.attr('data-parsley-required', 'false');
        });

        window.Parsley.on('field:success', function (field) {
            field.$element.parent().removeClass('error');
        });

        window.Parsley.on('field:error', function (field) {
            field.$element.parent().addClass('error');
        });


        // list with all fields that need to be with only latin characters
        var latinSelector = [
            '#id_firstname',
            '#id_lastname',
            '#id_apartment',
            '#id_building',
            '#id_houseno',
            '#id_street',
            '#id_city',
            '#id_county',
            '#id_zipcode',
            '#id_email',
            '#id_alt_email',
            '#id_alternate_email',
            '#id_cp1_email',
            '#id_cp2_email',
            '#id_co_field',
            '#id_placeofbirth',
            '#id_middlename',
            '#id_po_city',
            '#id_alternate_firstname',
            '#id_alternate_lastname',
            '#id_address_info',
            '#id_co_field',
            '#id_locality',
            '#id_district',
            '#id_cp1_firstname',
            '#id_cp1_lastname',
            '#id_cp2_firstname',
            '#id_cp2_lastname',
            '#id_residential_address',
            '#id_residential_county',
            '#id_residential_zipcode',
            '#id_postal_address',
            '#id_postal_zipcode',
            '#id_postal_county',
            '#id_previous_lastname',
            '#id_new_street',
            '#id_new_city',
            '#id_new_co_field',
            '#id_new_apartment',
            '#id_additional_address_info',
            '#id_previous_lastname',
            '#id_donor_id',
            '#id_gp_name',
            '#id_gp_town',
            '#id_new_houseno',
            '#id_new_address_info',
            '#id_new_po_box',
            '#id_new_po_name',
            '#id_new_building',
            '#id_new_locality',
            '#id_new_district',
            '#id_company',
            '#id_holder',
            '#id_account_name'
        ];

        // add each element to latin validator, latin characters check
        for (var i = 0; i < latinSelector.length; i++) {
            $(latinSelector[i]).attr('data-parsley-latin', '');
        }

        $('form').on('submit', function (e) {
            // disable the submit button in successful submission
            var $this = $(this);
            $this.parsley().validate();

            $('.address_error_field.address-error-visible, .new_address_error_field.address-error-visible').hide().removeClass('address-error-visible');

            if ($this.parsley().isValid()) {
                $this.find('[type="submit"]').each(function() {
                    var $this = $(this);
                    $this.attr('disabled', 'disabled');
                    $this.addClass('disabled');
                    $this.val($this.attr('data-disabled-label') || 'Please wait');
                });

                try {
                    var dldata = {
                        'event': 'form_submit',
                        'dkms.webforms.form_id': $this.attr('id'),
                        'dkms.webforms.language': window.DKMS.LANGUAGE,
                        'dkms.webforms.country': window.DKMS.COUNTRY_CODE,
                        'dkms.webforms.context': window.DKMS.CONTEXT,
                        'dkms.webforms.type': window.DKMS.TYPE,
                        'dkms.webforms.variant': window.DKMS.VARIANT,
                        'dkms.webforms.build': window.DKMS.BUILD
                    };

                    $this.find('input[name="amount"]').each(function() {
                        var k = 'dkms.webforms.' + window.DKMS.TYPE + '.' + $(this).attr('name');
                        dldata[k] = $(this).val();
                    });

                    window.dataLayer.push(dldata);
                } catch(exc) {
                    Sentry.captureException(exc);
                }

                return true;
            }

            $('html, body').stop().animate({
                scrollTop: DKMS.Utils.topOfFirstError()
            }, '500');

            e.preventDefault();
        });

        window.DKMS.datePickerInit = function() {
            $('.datepicker').each(function() {
                var $this = $(this);

                var opts = {};
                try {
                    opts = {
                        firstDay: Pikaday.i18n._momentLocale._week.dow,
                        i18n: Pikaday.i18n // see locale js
                    };

                    var yearRange = $this.attr('data-pikaday-yearrange');
                    if (yearRange) {
                        yearRange = yearRange.split('-');
                        opts.yearRange = yearRange.length >= 2 ? yearRange.slice(0,2) : yearRange[0];
                    }

                    var minDate = $this.attr('data-pikaday-min');
                    if (minDate) {
                        opts.minDate = moment(minDate, 'YYYY-MM-DD').toDate();
                    }

                    var maxDate = $this.attr('data-pikaday-max');
                    if (maxDate) {
                        opts.maxDate = moment(maxDate, 'YYYY-MM-DD').toDate();
                    }

                    var format = $this.attr('data-pikaday-format');
                    opts.format = format || Pikaday.i18n._format || Pikaday.i18n._momentLocale._longDateFormat.L;

                    opts.defaultDate = moment($this.val(), opts.format).toDate();
                    opts.setDefaultDate = true;
                } catch (exc) {
                    Sentry.captureException(exc);
                }

                $this.pikaday(opts);
            });
        };

        $('[data-phone-verification]').each(function(_idx, elem) {
            elem = $(elem);

            var field = $('#id_' + elem.data('phone-verification'));
            field.on('keyup', function() {
                elem.val('');   // reset verification code field on each change in phone number field
            });

            var btn = $('<button>Verify my phone number</button>');
            field.parent().append(btn);

            var number = 0;
            var verify = function() {
                if (number === field.val()) {
                    return;
                }

                number = field.val();

                var csrftoken = $('[name=csrfmiddlewaretoken]').val();

                field.parsley().validate();
                if (!field.parsley().isValid()) {
                    return;
                }

                if (window.DKMS.CONTEXT !== 'prod') {
                    number = elem.val() || number;
                }

                elem.val('');

                $.post('/api/verification/phone', {
                    'phone_number': number,
                    'country': window.DKMS.COUNTRY_CODE,
                    'csrfmiddlewaretoken': csrftoken
                })
                    .done(function() {
                        $('.phone-verification-message.error').hide();
                        $('.phone-verification-message.sent').show();
                        elem.focus();
                    })
                    .fail(function() {
                        $('.phone-verification-message.sent').hide();
                        $('.phone-verification-message.error').show();
                        field.focus();
                    });
            };

            btn.on('click', function(e) {
                e.preventDefault();
                verify();
            });
            //field.on('blur', verify.bind(this));
        });

        $('input[name="dataprotectionprivacy"]').each(function(_idx, elem) {
            var captchaContainer = $('.g-recaptcha');
            if (!captchaContainer.length) {
                return;
            }

            DKMS.Utils.loadScript(
                'g-recaptcha-dataprotection',
                'https://www.google.com/recaptcha/api.js?onload=gReCaptchaOnLoadCallback&render=explicit'
            );
        });

        var body = $('body');
        if (body.hasClass('country-DE')) {
            new DKMS.DE();
        } else if (body.hasClass('country-PL')) {
            new DKMS.PL();
        } else if (body.hasClass('country-US')) {
            new DKMS.US();
        } else if(body.hasClass('country-GB')){
            new DKMS.GB();
        } else if(body.hasClass('country-CL')){
            new DKMS.CL();
        } else if(body.hasClass('country-IN')){
            new DKMS.IN();
        } else if(body.hasClass('country-ZA')){
            new DKMS.ZA();
        }
    };

    return f;
})();

DKMS.Maps = (function(){
    var Autocompleter = (function(){
        var f = function(countries, externalConfig){
            var autocomplete,
                error = false,
                defaultConfig = {
                    addressFieldId: 'id_address',
                    errorNoticeSelector: '.address_error_field',
                    affectedFieldSelector: [
                        '.street',
                        '.houseno',
                        '.apartment',
                        '.zipcode',
                        '.city',
                        '.co_field',
                        '.building',
                        '.county',
                        '.country',
                        '.country_code',
                        '.state',
                        '.region',
                        '.address_info',
                        '.locality',
                        '.district',
                        '.locality',
                        '.state'
                    ],
                    'DE': {
                        'street_number__long_name': 'id_houseno',
                        'route__short_name': 'id_street',
                        'locality__long_name': 'id_city',
                        'postal_code__long_name': 'id_zipcode',
                        'country__long_name': 'id_country',
                        'country__short_name': 'id_country_code'
                    },
                    'PL': {
                        'street_number__long_name': 'id_houseno',
                        'route__long_name': 'id_street',
                        'locality__long_name': 'id_city',
                        'postal_code__long_name': 'id_zipcode',
                        'country__long_name': 'id_country',
                        'country__short_name': 'id_country_code'
                    },
                    'GB': {
                        'street_number__long_name': 'id_houseno',
                        'route__long_name': 'id_street',
                        'locality__long_name': 'id_city',
                        'postal_town__long_name': 'id_city',
                        'postal_code__long_name': 'id_zipcode',
                        'administrative_area_level_1__short_name': 'id_county',
                        'country__long_name': 'id_country',
                        'country__short_name': 'id_country_code'
                    },
                    'US': {
                        'street_number__long_name': 'id_houseno',
                        'route__long_name': 'id_street',
                        'locality__long_name': 'id_city',
                        'sublocality_level_1__long_name': 'id_city',
                        'postal_code__long_name': 'id_zipcode',
                        'administrative_area_level_1__short_name': 'id_state',
                        'country__long_name': 'id_country',
                        'country__short_name': 'id_country_code'
                    },
                    'CL': {
                        'street_number__long_name': 'id_houseno',
                        'route__long_name': 'id_street',
                        'administrative_area_level_1__long_name': 'id_region',
                        'locality__long_name': 'id_city',
                        'country__long_name': 'id_country',
                        'country__short_name': 'id_country_code',
                        'postal_code__long_name': 'id_zipcode'
                    },
                    'IN': {
                        'street_number__long_name': 'id_houseno',
                        'route__long_name': 'id_street',
                        'administrative_area_level_2__long_name': 'id_district',
                        'postal_code__long_name': 'id_zipcode',
                        'sublocality_level_1__long_name': 'id_locality',
                        'locality__long_name': 'id_city',
                        'administrative_area_level_1__short_name': 'id_state',
                        'country__long_name': 'id_country',
                        'country__short_name': 'id_country_code'
                    }
                },
                config,
                addressField,
                errorNotice,
                errorTimeout;

            function onPlaceChanged(countries) {
                var place = autocomplete.getPlace(),
                    cc = countries[0],
                    autocompleted = false;

                if (!cc || !config[cc]) {
                    cc = DKMS.COUNTRY_CODE;
                }

                // initialize the country of the address given.
                var countryOfAddress = String();

                if (place && place.address_components) {
                    // search in the object where the address country is,
                    // set countryOfAddress to the given country

                    var i;
                    for (i = 0; i < place.address_components.length; i++) {
                        if (place.address_components[i].types[0] === 'country') {
                            countryOfAddress = place.address_components[i].short_name;
                        }
                    }

                    for (i = 0; i < place.address_components.length; i++) {
                        var addressType = place.address_components[i].types[0],
                            val, id;

                        val = place.address_components[i].long_name;
                        id = config[cc][addressType + '__long_name'];
                        if (!id) { // fallback old behaviour
                            id = config[cc][addressType];
                        }

                        var element;
                        if (id) {
                            element = $('#' + id);
                            if (element.length) {
                                autocompleted = true;

                                // Chilenian cities need to be set uppercase to be recognized
                                if (countryOfAddress === 'CL' && (id === 'id_city' || id === 'id_new_city')) {
                                    val = val.toUpperCase();
                                }

                                // missalignment between google results for regions and our regions
                                if (countryOfAddress === 'CL' && (id === 'id_region' || id === 'id_new_region')) {
                                    var valModified = val.replace(/\W/g, '').toUpperCase();
                                    var selectRegions = document.getElementById('id_region');
                                    for (var iter = 0; iter < selectRegions.length; iter++) {
                                        var optionElement = selectRegions.options[iter].value.replace(/\W/g, '');
                                        if (optionElement.includes(valModified)) {
                                            val = selectRegions.options[iter].value;
                                            break;
                                        }
                                    }

                                }

                                element.val(val);
                                element.parsley().validate();
                            }
                        }

                        val = place.address_components[i].short_name;
                        id = config[cc][addressType + '__short_name'];

                        //county has to be filled only for USA and Canada, the rest of
                        //the countries should get an empty field
                        if (config[cc][addressType + '__short_name'] === 'id_county') {
                            if (countryOfAddress !== 'US' && countryOfAddress !== 'CA') {
                                val = String();
                            }
                        }

                        if (id) {
                            element = $('#' + id);
                            if (element.length) {
                                autocompleted = true;
                                element.val(val);
                                element.parsley().validate();
                            }
                        }
                    }
                }

                try {
                    $('#id_geolat').val(place.geometry.location.lat());
                    $('#id_geolng').val(place.geometry.location.lng());
                } catch(e){
                    // we don't care
                }

                if(errorTimeout){
                    window.clearTimeout(errorTimeout);
                }

                if(autocompleted === false && !error){
                    errorTimeout = window.setTimeout(function(){
                        errorNotice.show();
                    }, 2000);
                }

                addressField.parents('.row:first').find('li.fieldwrapper').not('.address').removeClass('hidden');
                addressField.parent().addClass('hidden');
                addressField.attr('data-parsley-required', 'false');
            }

            config = externalConfig || defaultConfig;
            addressField = $('#' + config.addressFieldId);
            errorNotice = addressField.parents('ul:first').find(config.errorNoticeSelector);

            var hasInitialValues = false,
                affectedFields = $(config.affectedFieldSelector);
            for(var i=0, len=affectedFields.length; i<len; i++){
                var affectedField = $(affectedFields[i]),
                    affectedFieldInput = affectedField.find('input'),
                    val = affectedFieldInput.val();

                // checkboxes etc. always have a value, skip them to avoid hiding the google places autocomplete field
                if (affectedFieldInput.attr('type') !== 'text') {
                    continue;
                }

                if (val && val !== '') {
                    hasInitialValues = true;
                }
            }

            if (hasInitialValues) {
                addressField.parents('.row:first').find('li.fieldwrapper').not('.address').removeClass('hidden');
                addressField.parent().addClass('hidden');
                addressField.attr('data-parsley-required', 'false');
            } else {
                addressField.parents('fieldset').find(config.affectedFieldSelector.join(',')).addClass('hidden');
            }

            errorNotice.on('click', function () {
                addressField.parents('.row:first').find('li.fieldwrapper').not('.address').removeClass('hidden');
                addressField.parent().addClass('hidden');
                addressField.attr('data-parsley-required', 'false');
                errorNotice.hide().removeClass('address-error-visible');
            });

            addressField.keydown(function(ev) {
                // get result count from google
                window.setTimeout(function(){
                    var resultCount = $('.pac-container .pac-item').length;

                    if(resultCount === 0 && !error && addressField.val().length !== 0){
                        error = true;
                        errorNotice.show().addClass('address-error-visible');
                    } else if(addressField.val().length === 0 || resultCount > 0){
                        errorNotice.hide().removeClass('address-error-visible');
                        error = false;
                    }

                }, 2000);

                if (ev.keyCode === 13) {
                    // hide the error message permanently
                    addressField.parents('.row:first').addClass('hideMapError');
                    errorNotice.hide().removeClass('address-error-visible');
                    ev.preventDefault();
                    if(!error){
                        onPlaceChanged(countries);
                    }
                    return false;
                }
            });

            var addressFieldElement = document.getElementById(config.addressFieldId);

            if(!addressFieldElement){
                return;
            }

            var acConfig = {
                types: ['address']
            };

            var restrictToCountry = addressField.attr('data-autocomplete-restrict-country') !== 'false';
            if (restrictToCountry) {
                acConfig.componentRestrictions = {
                    country: countries
                };
            }

            autocomplete = new google.maps.places.Autocomplete(addressFieldElement, acConfig);

            // this is very important, else we would have to pay for ALL returned data
            // @see https://developers.google.com/maps/documentation/javascript/places-autocomplete#get_place_information
            autocomplete.setFields(['address_components']);

            autocomplete.addListener('place_changed', onPlaceChanged.bind(this, countries));
        };

        return f;
    })();


    function init() {
        var countries = [ DKMS.COUNTRY_CODE ];
        // default autocompleter
        new Autocompleter(countries);

        // additional autocompleters, e.g. addressupdate forms
        if (typeof(DKMS.AddressHelper) != 'undefined') {
            for (var autoCompleterName in DKMS.AddressHelper) {
                new Autocompleter(countries, DKMS.AddressHelper[autoCompleterName]);
            }
        }
    }

    return {
        'init': init
    };

})();

DKMS.GB = (function(){
    var f = function () {
        // set visible elements by selection of stones/feet or kg/cm
        var personalInfo = $('.personalinfo fieldset');
        personalInfo.addClass($('.measurement :checked').val());

        $('.measurement input').on('change', function () {
            personalInfo.attr('class', '');
            personalInfo.addClass($(this).val());
        });

        var kgSet = (function(){
            return $('#id_weight_kg').val() !== '' &&
                $('#id_height_cm').val() !== '';
        })();

        var sfSet = (function(){
            return $('#id_weight_st').val() !== '' &&
                $('#id_weight_lbs').val() !== '' &&
                $('#id_height_ft').val() !== '' &&
                $('#id_height_in').val() !== '';
        })();

        // check if we have received input for height / weight via URL parameter
        var bmiSet = kgSet || sfSet;

        if(bmiSet){
            personalInfo.addClass('bmi-set');
        } else {
            if($('#id_weight_kg').val() !== '' || $('#id_height_cm').val() !== ''){
                var measurementRadio = $('#id_measurement_1');
                measurementRadio.prop('checked', 'checked');
                measurementRadio.trigger('change');
            }
        }

        var hasBirthDateInUrl = document.location.search.indexOf('birthdate=') > -1;
        $(['month', 'day', 'year']).each(function(_idx, id) {
            try {
                var f = $('input#id_' + id);
                f.parent('.fieldwrapper').toggleClass('eleg-hidden', hasBirthDateInUrl);
            } catch (e) {
                // pass
            }
        });

        $('[name=salutation]').on('change', function() {
            var val = parseInt($(this).val());

            var m, f;
            if (val >= 5) {
                m = false; f = false;
            } else if (val >= 2) {
                m = false; f = true;
            } else if (val === 1) {
                m = true; f = false;
            } else {
                return;
            }

            $('#id_sex_0').prop('checked', m);
            $('#id_sex_1').prop('checked', f);

            $('.fieldwrapper.sex').toggle(!m && !f);
        });

        // special case for gb form, dont submit form from the start, instead show second "page"
        $('.nextPageBtn').on('click', function () {
            // check if form is valid
            var $form = $('#regForm');

            var pageOneElements = $('.no:visible [name]'),
                isValid = true;
            for(var i in pageOneElements){
                if(!pageOneElements.hasOwnProperty(i)){
                    continue;
                }
                try {
                    var element = $(pageOneElements[i]);
                    element.parsley().validate();
                    if(!element.parsley().isValid()){
                        isValid = false;
                    }
                } catch(e) {
                    // we don't care
                }
            }

            if(isValid === true){
                // initialize personal data summary on second page
                var personalSelector = [
                    '.fieldwrapper.salutation',
                    '.fieldwrapper.firstname',
                    '.fieldwrapper.lastname',
                    '.fieldwrapper.middlename',
                    '.fieldwrapper.gender',
                    '.fieldwrapper.day',
                    '.fieldwrapper.month',
                    '.fieldwrapper.year',
                    '.fieldwrapper.weight',
                    '.fieldwrapper.height',
                    '.fieldwrapper.apartment',
                    '.fieldwrapper.building',
                    '.fieldwrapper.street',
                    '.fieldwrapper.houseno',
                    '.fieldwrapper.zipcode',
                    '.fieldwrapper.city',
                    '.fieldwrapper.county',
                    '.fieldwrapper.mobile',
                    '.fieldwrapper.phone',
                    '.fieldwrapper.email',
                    '.fieldwrapper.alt_email',
                    '.fieldwrapper.ethnicity',
                    '.fieldwrapper.source',
                ];

                var data = [],
                    elements = $(personalSelector.join(',')),
                    elementCount = elements.length;

                elements.each(function () {
                    var $this = $(this),
                        input = $this.find('input'),
                        select = $this.find('select'),
                        label = $this.find('label'),
                        val;

                    if(input.length === 1){
                        val = input.val();
                    } else {
                        val = select.find('option:selected').text();
                    }

                    try {
                        data.push(['<li>', DKMS.Utils.escapeHtml(label.contents().get(0).nodeValue), '</li>', '<li>', DKMS.Utils.escapeHtml(val) || '&nbsp;', '</li>'].join(''));
                    } catch (e) {
                        // some labels are empty
                    }

                    if(!--elementCount){
                        $('.consent_1 .description:first ul').html(data.join(''));
                    }
                });

                // get physician data
                var physicianSelector = [
                    '.gp_name',
                    '.gp_town',
                    '.gp_phone'
                ];

                var gpData = [],
                    gpElements = $(physicianSelector.join(',')),
                    gpElementCount = gpElements.length;

                gpElements.each(function () {
                    var $this = $(this),
                        input = $this.find('input'),
                        label = $this.find('label'),
                        val = input.val();

                    try {
                        gpData.push(['<li>', DKMS.Utils.escapeHtml(label.contents().get(0).nodeValue), '</li>', '<li>', DKMS.Utils.escapeHtml(val) || '&nbsp;', '</li>'].join(''));
                    } catch (e) {
                        // some labels are empty
                    }

                    if(!--gpElementCount){
                        $('.consent_2 .description:first ul').html(gpData.join(''));
                    }
                });

                $('#id_electronic_signature').parsley().reset();
                $form.addClass('page2');
                $('body').addClass('page2');
                $('html, body').stop().animate({
                    scrollTop:0
                }, '300');
            } else {
                var addressFieldId = 'id_address',
                    addressField = $('#' + addressFieldId);

                addressField.parents('.row:first').find('li.fieldwrapper').not('.address').removeClass('hidden');
                addressField.parent().addClass('hidden');

                $('.address_error_field.address-error-visible, .new_address_error_field.address-error-visible').hide().removeClass('address-error-visible');

                $('html, body').stop().animate({
                    scrollTop: DKMS.Utils.topOfFirstError()
                }, '500');
            }
        });


        $('.backBtn').on('click', function () {
            $('#regForm, body').removeClass('page2');
            $('html, body').stop().animate({
                scrollTop:0
            }, '300');
        });
    };

    return f;
})();

DKMS.US = (function(){
    var f = function(){
        var currentPage = 1;

        var addSummaryContainer = function(selectors, target){
            var data = [];

            selectors.forEach(function (element) {
                var $this = $(element),
                    input = $this.find('input'),
                    select = $this.find('select'),
                    label = $this.find('label'),
                    labelElem,
                    labelVal,
                    glue,
                    summaryLabel,
                    summaryLabelText,
                    val,
                    name;

                if ($this.length > 1) {
                    val = [];
                    glue = ' ';

                    for (var i = 0, len = $this.length; i < len; i++) {
                        var el = $this.get(i),
                            $element = $(el);

                        input = $element.find('input');
                        label = $element.find('label');
                        summaryLabel = input.data('summary-label');
                        if (summaryLabel) {
                            summaryLabelText = summaryLabel;
                        }

                        val.push(input.val());
                        if (!labelElem) {
                            labelElem = label;
                            name = input.attr('name');
                            if (name === 'month') {
                                glue = '/';
                            } else if (name === 'phone1' || name === 'cellphone1' || name === 'alternate_phone1'){
                                glue = '-';
                            }
                        }
                    }
                    val = val.join('') !== '' ?
                        val.join(glue) :
                        '&nbsp;';

                    labelVal = '';

                    if(summaryLabelText){
                        labelVal = summaryLabelText;
                    } else if(labelElem.contents() && labelElem.contents().get(0) && labelElem.contents().get(0).nodeValue){
                        labelVal = labelElem.contents().get(0).nodeValue;
                    }

                    if(labelVal === ''){
                        return;
                    }

                    data.push(['<li>', DKMS.Utils.escapeHtml(labelVal), '</li>', '<li class="summary-' + DKMS.Utils.escapeHtml(name) + '">', DKMS.Utils.escapeHtml(val), '</li>'].join(''));
                } else {
                    if (input.length === 1) {
                        val = input.val();
                        name = input.attr('name');
                    } else if(select.length > 0) {
                        val = select.find('option:selected').text();
                        name = select.attr('name');
                    } else {
                        // handle radiobuttons
                        for(var j = 0, jlen = input.length; j<jlen; j++){
                            var inputElement = $(input[j]);
                            if(inputElement.is(':checked')){
                                val = inputElement.parent().text();
                                break;
                            }
                        }
                    }

                    summaryLabel = input.data('summary-label');

                    labelVal = '';

                    if (summaryLabel) {
                        labelVal = summaryLabel;
                    } else {
                        try {
                            labelVal = label.contents().get(0).nodeValue;
                        } catch (e) {
                            // some labels are empty
                        }
                    }

                    if (labelVal === '') {
                        return;
                    }

                    data.push(['<li>', DKMS.Utils.escapeHtml(labelVal), '</li>', '<li class="summary-' + DKMS.Utils.escapeHtml(name) + '">', DKMS.Utils.escapeHtml(val) || '&nbsp;', '</li>'].join(''));
                }
            });

            $(target).html(data.join(''));
        };

        // special case for us form, dont submit form from the start, instead show second "page"
        $('.nextPageBtn').on('click', function () {
            var $form = $('#regForm'),
                $body = $('body');

            if(currentPage === 1) {
                // check if form is valid
                var pageOneElements = $('.no:visible [name]'),
                    isValid = true;
                for (var i in pageOneElements) {
                    if (!pageOneElements.hasOwnProperty(i)) {
                        continue;
                    }
                    try {
                        var element = $(pageOneElements[i]);
                        element.parsley().validate();
                        if (!element.parsley().isValid()) {
                            isValid = false;
                        }
                    } catch (e) {
                        // we don't care
                    }
                }

                isValid = isValid && validateAncestry();

                if (isValid === true) {
                    $('#id_electronic_signature').parsley().reset();
                    $form.addClass('page2');
                    $body.addClass('page2');
                    currentPage = 2;
                    $('html, body').stop().animate({
                        scrollTop: 0
                    }, '300');
                } else {
                    var addressFieldId = 'id_address',
                        addressField = $('#' + addressFieldId);

                    addressField.parents('.row:first').find('li.fieldwrapper').not('.address').removeClass('hidden');
                    addressField.parent().addClass('hidden');

                    $('.address_error_field.address-error-visible, .new_address_error_field.address-error-visible').hide().removeClass('address-error-visible');

                    $('html, body').stop().animate({
                        scrollTop: DKMS.Utils.topOfFirstError()
                    }, '500');
                }
            } else if (currentPage === 2) {
                var elem = $('#id_electronic_signature');
                elem.parsley().validate();
                if (!elem.parsley().isValid()) {
                    $('html, body').stop().animate({
                        scrollTop: DKMS.Utils.topOfFirstError()
                    }, '500');
                    return;
                }

                // show confirmation summary
                var personalSelector = [
                    '.fieldwrapper.sex',
                    '.fieldwrapper.firstname, .fieldwrapper.lastname',
                    '.fieldwrapper.street, .fieldwrapper.houseno',
                    '.fieldwrapper.city',
                    '.fieldwrapper.state',
                    '.fieldwrapper.zipcode',
                    '.fieldwrapper.po_box',
                    '.fieldwrapper.po_city',
                    '.fieldwrapper.po_state',
                    '.fieldwrapper.po_zipcode',
                    '.fieldwrapper.mobile',
                    '.fieldwrapper.phone',
                    '.fieldwrapper.email',
                    '.fieldwrapper.month, .fieldwrapper.day, .fieldwrapper.year',
                    '.fieldwrapper.height',
                    '.fieldwrapper.weight_lbs',
                    '.fieldwrapper.source',
                ];

                addSummaryContainer(personalSelector, '.summary .description:first ul');

                var alternateInfoSelector = [
                    '.fieldwrapper.alternate_firstname, .fieldwrapper.alternate_lastname',
                    '.fieldwrapper.alternate_phone',
                    '.fieldwrapper.alternate_email',
                    '.fieldwrapper.relationship'
                ];

                addSummaryContainer(alternateInfoSelector, '.summary-alternate .description:first ul');

                $('#id_electronic_signature').parsley().reset();
                $form.addClass('page3');
                $form.removeClass('page2');
                $body.addClass('page3');
                $body.removeClass('page2');
                currentPage = 3;
                $('html, body').stop().animate({
                    scrollTop: 0
                }, '300');
            }

        });

        $('.backBtn').on('click', function () {
            $('#regForm, body').removeClass('page' + currentPage);
            currentPage--;
            $('#regForm, body').addClass('page' + currentPage);
            if(currentPage === 1){
                $('.fieldwrapper.eleg-hidden').removeClass('eleg-hidden');
            }
            $('html, body').stop().animate({
                scrollTop:0
            }, '300');
        });

        $(['month', 'day', 'year', 'weight_lbs', 'height']).each(function(_idx, id) {
            try {
                var f = $('.country-US.package-registration #id_' + id);
                f.parent('.fieldwrapper').toggleClass('eleg-hidden', !!f.val().length);
            } catch (e) {
                // pass
            }
        });

        $('body').on('click', '.summary-height, .summary-weight_lbs, .summary-month', function(){
            $('.fieldwrapper.eleg-hidden').removeClass('eleg-hidden');
            $('body, #regForm').removeClass('page3');
            $('html, body').stop().animate({
                scrollTop: $('.fieldwrapper.month').offset().top - 20
            }, '300');
            currentPage = 1;
        });

        $('.ancestry_label_white, .ancestry_label_asian, .ancestry_label_black, .ancestry_label_native, .ancestry_label_pacific, .ancestry_label_latin').each(function(){
            var $this = $(this),
                input = $this.find('input');

            if(input.is(':checked')){
                $this.next('.fieldwrapper').addClass('open');
            }
        });

        $('#id_po_box').on('change', function() {
            $('#id_po_city').parsley().validate();
            $('#id_po_zipcode').parsley().validate();
            $('#id_po_state').parsley().validate();
        });

        var validateAncestry = function () {
            if($('#regForm').length === 0){
                return true;
            }
            $('.ancestry_error_field').hide();

            var ancestryMap = {
                'id_ancestry_fields_native_0': 0,
                'id_ancestry_fields_native_1': 0,
                'id_ancestry_fields_native_2': 0,
                'id_ancestry_fields_native_3': 0,
                'id_ancestry_fields_black_0': 0,
                'id_ancestry_fields_black_1': 0,
                'id_ancestry_fields_black_2': 0,
                'id_ancestry_fields_black_3': 0,
                'id_ancestry_fields_asian_0': 0,
                'id_ancestry_fields_asian_1': 0,
                'id_ancestry_fields_asian_2': 0,
                'id_ancestry_fields_asian_3': 0,
                'id_ancestry_fields_asian_4': 0,
                'id_ancestry_fields_asian_5': 0,
                'id_ancestry_fields_asian_6': 0,
                'id_ancestry_fields_pacific_0': 0,
                'id_ancestry_fields_pacific_1': 0,
                'id_ancestry_fields_pacific_2': 0,
                'id_ancestry_fields_pacific_3': 0,
                'id_ancestry_fields_white_0': 0,
                'id_ancestry_fields_white_1': 0,
                'id_ancestry_fields_white_2': 0,
                'id_ancestry_fields_white_3': 0,
                'id_ancestry_fields_white_4': 0,
                'id_ancestry_fields_white_5': 0,
                'id_ancestry_fields_white_6': 0,
                'id_ancestry_fields_white_7': 0,
                'id_ancestry_fields_white_8': 0,
                'id_ancestry_fields_white_9': 0,
                'id_ancestry_fields_latin_0': 0,
                'id_ancestry_fields_latin_1': 0,
                'id_ancestry_fields_latin_2': 0,
                'id_ancestry_fields_latin_3': 0,
                'id_ancestry_fields_native_4': 0,
                'id_ancestry_fields_black_5': 0
            };

            // serialize ancestry fields
            var checkboxes = $('.ancestry [type="checkbox"]');
            for(var i in checkboxes){
                if(!checkboxes.hasOwnProperty(i)){
                    continue;
                }

                var $this = $(checkboxes[i]);
                if(typeof ancestryMap[$this.attr('id')] == 'undefined'){
                    continue;
                }
                ancestryMap[$this.attr('id')] = $this.is(':checked') ? 1 : 0;
            }

            var ancestryString = '';
            for(var j in ancestryMap){
                ancestryString += ancestryMap[j];
            }

            if(ancestryString.indexOf('1') == -1){
                var errorField = $('.ancestry_error_field');
                errorField.show();
                errorField.addClass('parsley-error');
                return false;
            } else {
                var ancestryStringElement = $('#ancestryString');
                if(ancestryStringElement.length != 0){
                    ancestryStringElement.val(ancestryString);
                } else {
                    $('#regForm').append('<input id="ancestryString" type="hidden" name="ancestry" value="' + ancestryString + '"/>');
                }
                return true;
            }
        };

        // @see #JAD-1596
        $('.variant-mhsa #id_attend_event input').on('change', function(e) {
            if (e.target.value === 'yes') {
                $('.media_rights_granted, .media_rights_granted__before').show();
                $('#id_media_rights_granted').attr('required', 'required');
            } else {
                $('.media_rights_granted, .media_rights_granted__before').hide();
                $('#id_media_rights_granted').removeAttr('required').parsley().validate();
            }
        });
    };
    return f;
})();

DKMS.ButtonGroup = (function () {
    var f = function(selector, onChange) {
        $(selector).find('[type="radio"]').on('change', function() {
            var $this = $(this);

            $(selector).find('li.active').removeClass('active');
            if ($this.prop('checked') == true) {
                $this.closest('li').addClass('active');
            }

            if (onChange) {
                onChange($this);
            }
        });

        $(selector).find('input').each(function() {
            if ($(this).prop('checked')) {
                $(this).parents('li').addClass('active');
            } else {
                $(this).parents('li').removeClass('active');
            }
        });

        $(selector).find('input:radio[checked]').change();
    };

    return f;
})();

DKMS.DE = (function() {
    var f = function() {
        // co field
        var coInput = $('.co_field input'),
            link_text = coInput.attr('data-show-label'),
            label = $('.co_field label'),
            label_text = label.text();

        label.text(link_text).addClass('input-hidden').on('click', function() {
            $(this).text(label_text).removeClass('input-hidden');
            coInput.show();
        });

        coInput.hide().attr('data-label-text', label_text);

        // sort by translated string
        try {
            $('.ancestry select').html($('.ancestry select option').sort(function(a, b) {
                return a.text == b.text ? 0 : a.text.localeCompare(b.text);
            }));

            $('.ancestry select option[value="RU"]').insertBefore('.ancestry select option:first-child');
            $('.ancestry select option[value="PL"]').insertBefore('.ancestry select option:first-child');
            $('.ancestry select option[value="TR"]').insertBefore('.ancestry select option:first-child');
            $('.ancestry select option[value="DE"]').insertBefore('.ancestry select option:first-child');
            $('.ancestry select option[value="**"]').insertBefore('.ancestry select option:first-child');
            $('.ancestry select option[value=""]').insertBefore('.ancestry select option:first-child');
            $('.ancestry select option[selected]').prop('selected', true);
        } catch(e) {
            // ignore this if no localeCompare available
        }

        // either-mobile-or-phone
        $('#id_mobile').on('change', function() {
            try {
                // sometimes there's no phone field
                $('#id_phone').parsley().validate();
            } catch (e) {
                /* no-op */
            }
        });

        $('#id_phone').on('change', function() {
            try {
                // sometimes there's no mobile field
                $('#id_mobile').parsley().validate();
            } catch (e) {
                /* no-op */
            }
        });

        $('.nextPageBtn').on('click', function () {
            // check if form is valid
            var $form = $('#regForm');

            var pageOneElements = $('.no:visible [name]'),
                isValid = true;
            for(var i in pageOneElements){
                if(!pageOneElements.hasOwnProperty(i)){
                    continue;
                }
                try {
                    var element = $(pageOneElements[i]);
                    element.parsley().validate();
                    if(!element.parsley().isValid()){
                        isValid = false;
                    }
                } catch(e) {
                    // we don't care
                }
            }

            if(isValid === true){
                // initialize personal data summary on second page
                var personalSelector = [
                    '.fieldwrapper.salutation',
                    '.fieldwrapper.title',
                    '.fieldwrapper.firstname',
                    '.fieldwrapper.lastname'
                ];

                var addressSelector = [
                    '.fieldwrapper.street',
                    '.fieldwrapper.houseno',
                    '.fieldwrapper.apartment',
                    '.fieldwrapper.co_field',
                    '.fieldwrapper.zipcode',
                    '.fieldwrapper.city'
                ];

                var contactSelector = [
                    '.fieldwrapper.phone',
                    '.fieldwrapper.mobile',
                    '.fieldwrapper.email'
                ];

                var additionalInfoSelector = [
                    '.fieldwrapper.ancestry',
                    '.fieldwrapper.source'
                ];

                var addToSummary = function() {
                    var $this = $(this),
                        input = $this.find('input'),
                        select = $this.find('select'),
                        label = input.attr('data-label-text') ? input.attr('data-label-text') : $this.find('label').contents().get(0).nodeValue,
                        val;

                    if (input.length === 1) {
                        val = input.val();
                    } else if(select.length !== 0) {
                        val = select.val() ?
                            select.find('option:selected').text() :
                            '';
                    } else {
                        // handle radiobuttons
                        for(var j = 0, jlen = input.length; j<jlen; j++){
                            var inputElement = $(input[j]);
                            if(inputElement.is(':checked')){
                                val = inputElement.parent().text();
                                break;
                            }
                        }
                    }

                    try {
                        data.push(['<li>', DKMS.Utils.escapeHtml(label), '</li>', '<li>', DKMS.Utils.escapeHtml(val) || '&nbsp;', '</li>'].join(''));
                    } catch (e) {
                        // some labels are empty
                    }

                    if(!--elementCount) {
                        $('.consent_' + (parseInt(x)+1) + ' .description:first ul').html(data.join(''));
                    }
                };

                var selectorStack = [personalSelector, addressSelector, contactSelector, additionalInfoSelector];
                for(var x in selectorStack) {
                    var selectors = selectorStack[x],
                        data = [],
                        elements = $(selectors.join(',')),
                        elementCount = elements.length;

                    elements.each(addToSummary);
                }

                $form.addClass('page2');
                $('body').addClass('page2');
                $('html, body').stop().animate({
                    scrollTop:0
                }, '300');
            } else {
                var addressFieldId = 'id_address',
                    addressField = $('#' + addressFieldId);

                addressField.parents('.row:first').find('li.fieldwrapper').not('.address').removeClass('hidden');
                addressField.parent().addClass('hidden');

                $('.address_error_field.address-error-visible, .new_address_error_field.address-error-visible').hide().removeClass('address-error-visible');

                $('html, body').stop().animate({
                    scrollTop: DKMS.Utils.topOfFirstError()
                }, '500');
            }
        });

        $('.backBtn').on('click', function () {
            $('#regForm, body').removeClass('page2');
            $('html, body').stop().animate({
                scrollTop:0
            }, '300');
        });

    };

    return f;
})();

DKMS.PL = (function() {
    var f = function () {

        (function() {
            $('.nextPageBtn').on('click', function () {
                // check if form is valid
                var $form = $('#regForm'),
                    pageOneElements = $('.no:visible [name]'),
                    isValid = true;


                for (var i in pageOneElements) {
                    if (!pageOneElements.hasOwnProperty(i)) {
                        continue;
                    }

                    try {
                        var element = $(pageOneElements[i]);
                        element.parsley().validate();
                        if (!element.parsley().isValid()) {
                            isValid = false;
                        }
                    } catch(e) {
                        // no-op
                    }
                }

                if (isValid === true) {
                    // initialize personal data summary on second page
                    var personalSelector = [
                        '.fieldwrapper.salutation',
                        '.fieldwrapper.firstname',
                        '.fieldwrapper.lastname',
                        '.fieldwrapper.placeofbirth',
                        '.fieldwrapper.street',
                        '.fieldwrapper.houseno',
                        '.fieldwrapper.apartment',
                        '.fieldwrapper.zipcode',
                        '.fieldwrapper.city',
                        '.fieldwrapper.email',
                        '.fieldwrapper.phone',
                        '.fieldwrapper.source'
                    ];

                    var data = [],
                        elements = $(personalSelector.join(',')),
                        elementCount = elements.length;

                    elements.each(function () {
                        var $this = $(this),
                            input = $this.find('input'),
                            select = $this.find('select'),
                            label = $this.find('label'),
                            summaryLabel = input.data('summary-label'),
                            summaryLabelText = label.contents().get(0).nodeValue,
                            val;

                        if (summaryLabel) {
                            summaryLabelText = summaryLabel;
                        }

                        if(input.length === 1){
                            if (input.attr('type') === 'checkbox') {
                                val = input.get(0).checked ? 'Yes' : 'No';
                            } else {
                                val = input.val();
                            }
                        } else if (input.attr('type') === 'radio') {
                            input = $this.find('input:checked');
                            val = $.trim(input.parent('label').contents().get(1).nodeValue);
                        } else {
                            var opt = select.find('option:selected');
                            val = opt.attr('value') ? opt.text() : '-';
                        }

                        try {
                            data.push(['<li>', DKMS.Utils.escapeHtml(summaryLabelText), '</li>', '<li>', DKMS.Utils.escapeHtml(val) || '&nbsp;', '</li>'].join(''));
                        } catch (e) {
                            // some labels are empty
                        }

                        if (!--elementCount) {
                            $('.summary .description:first ul').html(data.join(''));
                        }
                    });

                    $form.addClass('page2');
                    $('body').addClass('page2');
                    $('html, body').stop().animate({
                        scrollTop:0
                    }, '300');
                } else {
                    var addressFieldId = 'id_address',
                        addressField = $('#' + addressFieldId);

                    addressField.parents('.row:first').find('li.fieldwrapper').not('.address').removeClass('hidden');
                    addressField.parent().addClass('hidden');

                    $('.address_error_field.address-error-visible, .new_address_error_field.address-error-visible').hide().removeClass('address-error-visible');

                    $('html, body').stop().animate({
                        scrollTop: DKMS.Utils.topOfFirstError()
                    }, '500');
                }
            });

            $('.backBtn').on('click', function () {
                $('#regForm, body').removeClass('page2');
                $('html, body').stop().animate({
                    scrollTop:0
                }, '300');
            });
        })();
    };

    return f;
})();

DKMS.CL = (function(){
    var f = function () {
        $('[name=salutation]').on('change', function(e) {
            var sx = parseInt($(e.target).val());

            $('[name=title]').find('option[value="Dr."]').text(sx === 2 ? 'Dra.' : 'Dr.');
        });

        try {
            $('.origin_country_father select').html($('.origin_country_father select option').sort(function(a, b) {
                return a.text == b.text ? 0 : a.text.localeCompare(b.text);
            }));
            $('.origin_country_father select option[value="CL"]').insertBefore('.origin_country_father select option:first-child');
            $('.origin_country_father select option[value=""]').insertBefore('.origin_country_father select option:first-child');
            $('.origin_country_father select option[selected]').prop('selected', true);

            $('.origin_country_mother select').html($('.origin_country_mother select option').sort(function(a, b) {
                return a.text == b.text ? 0 : a.text.localeCompare(b.text);
            }));
            $('.origin_country_mother select option[value="CL"]').insertBefore('.origin_country_mother select option:first-child');
            $('.origin_country_mother select option[value=""]').insertBefore('.origin_country_mother select option:first-child');
            $('.origin_country_mother select option[selected]').prop('selected', true);
        } catch(e) {
            // ignore this if no localeCompare available
        }

        $('.origin_country_father select, .origin_country_mother select')
            .on('change', function(ev) {
                var val = $(ev.target).find('option:selected').val(),
                    el = $(this).attr('data-toggle-visibility'),
                    f = $(el).find('select'),
                    showval = $(this).attr('data-toggle-showval');

                if (val === showval) {
                    $(el).removeClass('hidden');
                    $(f).attr('required', 'required');
                } else {
                    $(el).addClass('hidden');
                    $(f).removeAttr('required');
                }

                f.parsley().validate();
            })
            .change();

        (function() {
            var communes_and_regions = $('#id_city').find('optgroup').clone();
            var please_select = $($('#id_city').find('option')[0]).clone();
            var communes_and_regions_new = $('#id_new_city').find('optgroup').clone();

            $('#id_region').on('change', function(ev) {
                var region = $(ev.target).find('option:selected').val();
                var communes;
                if (region) {
                    communes = $.grep(communes_and_regions, function(n) {
                        return $(n).attr('label') == region;
                    });
                    communes.unshift(please_select);
                } else {
                    communes = communes_and_regions;
                }

                $('#id_city').html(communes);
            });

            $('#id_city').on('change', function(ev) {
                var region = $(ev.target).find('option:selected').parent('optgroup').attr('label');
                $('#id_region').val(region || '').parsley().validate();
            });

            $('#id_new_region').on('change', function(ev) {
                var region = $(ev.target).find('option:selected').val();
                var communes;
                if (region) {
                    communes = $.grep(communes_and_regions_new, function(n) {
                        return $(n).attr('label') == region;
                    });
                    communes.unshift(please_select);
                } else {
                    communes = communes_and_regions;
                }

                $('#id_new_city').html(communes);
            });

            $('#id_new_city').on('change', function(ev) {
                var region = $(ev.target).find('option:selected').parent('optgroup').attr('label');
                $('#id_new_region').val(region || '').parsley().validate();
            });
        })();

        // special case for CL form, dont submit form from the start, instead show second "page"
        $('.nextPageBtn').on('click', function () {
            // check if form is valid
            var $form = $('#regForm'),
                pageOneElements = $('.no:visible [name]'),
                isValid = true;

            for (var i in pageOneElements) {
                if (!pageOneElements.hasOwnProperty(i)) {
                    continue;
                }

                try {
                    var element = $(pageOneElements[i]);
                    element.parsley().validate();
                    if (!element.parsley().isValid()) {
                        isValid = false;
                    }
                } catch(e) {
                    // no-op
                }
            }

            if (isValid === true) {
                // initialize personal data summary on second page
                var personalSelector = [
                    '.fieldwrapper.salutation',
                    '.fieldwrapper.title',
                    '.fieldwrapper.firstname',
                    '.fieldwrapper.lastname',
                    '.fieldwrapper.rut_run',
                    '.fieldwrapper.origin_country_father',
                    '.fieldwrapper.ethnicity_father',
                    '.fieldwrapper.origin_country_mother',
                    '.fieldwrapper.ethnicity_mother',
                    '.fieldwrapper.po_box',
                    '.fieldwrapper.po_name',
                    '.fieldwrapper.street',
                    '.fieldwrapper.houseno',
                    '.fieldwrapper.address_info',
                    '.fieldwrapper.zipcode',
                    '.fieldwrapper.city',
                    '.fieldwrapper.region',
                    '.fieldwrapper.mobile',
                    '.fieldwrapper.use_whatsapp',
                    '.fieldwrapper.phone',
                    '.fieldwrapper.work_phone',
                    '.fieldwrapper.email',
                    '.fieldwrapper.alt_email',
                    '.fieldwrapper.source'
                ];

                var data = [],
                    elements = $(personalSelector.join(',')),
                    elementCount = elements.length;

                elements.each(function () {
                    var $this = $(this),
                        input = $this.find('input'),
                        select = $this.find('select'),
                        label = $this.find('label'),
                        val;

                    if(input.length === 1){
                        if (input.attr('type') === 'checkbox') {
                            val = input.get(0).checked ? 'Yes' : 'No';
                        } else {
                            val = input.val();
                        }
                    } else if (input.attr('type') === 'radio') {
                        input = $this.find('input:checked');
                        val = $.trim(input.parent('label').contents().get(1).nodeValue);
                    } else {
                        var opt = select.find('option:selected');
                        val = opt.attr('value') ? opt.text() : '-';
                    }

                    try {
                        data.push(['<li>', DKMS.Utils.escapeHtml(label.contents().get(0).nodeValue), '</li>', '<li>', DKMS.Utils.escapeHtml(val) || '&nbsp;', '</li>'].join(''));
                    } catch (e) {
                        // some labels are empty
                    }

                    if(!--elementCount){
                        $('.consent_1 .description:first ul').html(data.join(''));
                    }
                });

                $('#id_electronic_signature').parsley().reset();
                $form.addClass('page2');
                $('body').addClass('page2');
                $('html, body').stop().animate({
                    scrollTop:0
                }, '300');
            } else {
                $('html, body').stop().animate({
                    scrollTop: DKMS.Utils.topOfFirstError()
                }, '500');
            }
        });

        $('.backBtn').on('click', function () {
            $('#regForm, body').removeClass('page2');
            $('html, body').stop().animate({
                scrollTop:0
            }, '300');
        });
    };

    return f;
})();

DKMS.IN = (function() {
    var f = function () {
        $('.nextPageBtn').on('click', function () {
            // check if form is valid
            var $form = $('#regForm'),
                pageOneElements = $('.no:visible [name]'),
                isValid = true;

            for (var i in pageOneElements) {
                if (!pageOneElements.hasOwnProperty(i)) {
                    continue;
                }

                try {
                    var element = $(pageOneElements[i]);
                    element.parsley().validate();
                    if (!element.parsley().isValid()) {
                        isValid = false;
                    }
                } catch(e) {
                    // no-op
                }
            }

            if (isValid === true) {
                // initialize personal data summary on second page
                var personalSelector = [
                    '.fieldwrapper.sex',
                    '.fieldwrapper.title',
                    '.fieldwrapper.firstname',
                    '.fieldwrapper.lastname',
                    '.fieldwrapper.native_language',
                    '.fieldwrapper.origin_father',
                    '.fieldwrapper.native_language_father',
                    '.fieldwrapper.origin_mother',
                    '.fieldwrapper.native_language_mother',
                    '.fieldwrapper.co_field',
                    '.fieldwrapper.apartment',
                    '.fieldwrapper.building',
                    '.fieldwrapper.houseno',
                    '.fieldwrapper.street',
                    '.fieldwrapper.locality',
                    '.fieldwrapper.city',
                    '.fieldwrapper.zipcode',
                    '.fieldwrapper.district',
                    '.fieldwrapper.state',
                    '.fieldwrapper.mobile',
                    '.fieldwrapper.phone',
                    '.fieldwrapper.use_whatsapp',
                    '.fieldwrapper.email',
                    '.fieldwrapper.alt_email',
                    '.fieldwrapper.cp1_firstname',
                    '.fieldwrapper.cp1_lastname',
                    '.fieldwrapper.cp1_relationship',
                    '.fieldwrapper.cp1_phone',
                    '.fieldwrapper.cp1_email',
                    '.fieldwrapper.cp2_firstname',
                    '.fieldwrapper.cp2_lastname',
                    '.fieldwrapper.cp2_relationship',
                    '.fieldwrapper.cp2_phone',
                    '.fieldwrapper.cp2_email',
                    '.fieldwrapper.source'
                ];

                var data = [],
                    elements = $(personalSelector.join(',')),
                    elementCount = elements.length;

                elements.each(function () {
                    var $this = $(this),
                        input = $this.find('input'),
                        select = $this.find('select'),
                        label = $this.find('label'),
                        val;

                    if(input.length === 1){
                        if (input.attr('type') === 'checkbox') {
                            val = input.get(0).checked ? 'Yes' : 'No';
                        } else {
                            val = input.val();
                        }
                    } else if (input.attr('type') === 'radio') {
                        input = $this.find('input:checked');
                        val = $.trim(input.parent('label').contents().get(1).nodeValue);
                    } else {
                        var opt = select.find('option:selected');
                        val = opt.attr('value') ? opt.text() : '-';
                    }

                    var labelVal = '';
                    var summaryLabel = input.data('summary-label');
                    if (summaryLabel) {
                        labelVal = summaryLabel;
                    } else {
                        try {
                            labelVal = label.contents().get(0).nodeValue;
                        } catch (e) {
                            // some labels are empty
                        }
                    }

                    try {
                        var summaryDecoratorBefore = input.data('summary-decorator-before') || select.data('summary-decorator-before');
                        if (summaryDecoratorBefore) {
                            data.push([
                                '<li class="summary-decorator summary-decorator__before">',
                                DKMS.Utils.escapeHtml(summaryDecoratorBefore),
                                '</li><li>&nbsp;</li>'
                            ].join(''));
                        }

                        data.push([
                            '<li>',
                            DKMS.Utils.escapeHtml(labelVal),
                            '</li>',
                            '<li>',
                            DKMS.Utils.escapeHtml(val) || '&nbsp;',
                            '</li>'
                        ].join(''));
                    } catch (e) {
                        // some labels are empty
                    }

                    if(!--elementCount){
                        $('.consent_1 .description:first ul').html(data.join(''));
                    }
                });

                $form.addClass('page2');
                $('body').addClass('page2');
                $('html, body').stop().animate({
                    scrollTop:0
                }, '300');
            } else {
                $('html, body').stop().animate({
                    scrollTop: DKMS.Utils.topOfFirstError()
                }, '500');
            }
        });

        $('.backBtn').on('click', function () {
            $('#regForm, body').removeClass('page2');
            $('html, body').stop().animate({
                scrollTop:0
            }, '300');
        });
    };

    return f;
})();

DKMS.ZA = (function() {
    var f = function () {

        $('[name=salutation]').on('change', function() {
            var val = $(this).val(),
                m = false,
                f = false;

            switch (val) {
                case '':
                    $('.fieldwrapper.sex').toggle(false);
                    return;

                case 'Mr':
                    m = true;
                    break;

                case 'Mrs':
                case 'Miss':
                case 'Ms':
                    f = true;
            }

            $('#id_sex_0').prop('checked', m);
            $('#id_sex_1').prop('checked', f);

            $('.fieldwrapper.sex').toggle(!m && !f);
        }).trigger('change');

        $('.nextPageBtn').on('click', function () {
            // check if form is valid
            var $form = $('#regForm'),
                pageOneElements = $('.no:visible [name]'),
                isValid = true;

            for (var i in pageOneElements) {
                if (!pageOneElements.hasOwnProperty(i)) {
                    continue;
                }

                try {
                    var element = $(pageOneElements[i]);
                    element.parsley().validate();
                    if (!element.parsley().isValid()) {
                        isValid = false;
                    }
                } catch(e) {
                    // no-op
                }
            }

            if (isValid === true) {
                // initialize personal data summary on second page
                var personalSelector = [
                    '.fieldwrapper.za_citizen',
                    '.fieldwrapper.already_registered',
                    '.fieldwrapper.health_status',
                    '.fieldwrapper.diagnosed_disease',
                    '.fieldwrapper.birthdate',
                    '.fieldwrapper.weight',
                    '.fieldwrapper.height',

                    '.fieldwrapper.sex',
                    '.fieldwrapper.salutation',
                    '.fieldwrapper.firstname',
                    '.fieldwrapper.lastname',
                    '.fieldwrapper.identification',
                    '.fieldwrapper.delivery_date',
                    '.fieldwrapper.residential_apartment',
                    '.fieldwrapper.residential_houseno',
                    '.fieldwrapper.residential_street',
                    '.fieldwrapper.residential_city',
                    '.fieldwrapper.residential_zipcode',
                    '.fieldwrapper.residential_province',
                    '.fieldwrapper.delivery_company',
                    '.fieldwrapper.delivery_house_number',
                    '.fieldwrapper.delivery_street_name',
                    '.fieldwrapper.delivery_city',
                    '.fieldwrapper.delivery_zipcode',
                    '.fieldwrapper.delivery_province',
                    '.fieldwrapper.delivery_instructions',

                    '.fieldwrapper.mobile',
                    '.fieldwrapper.phone',
                    '.fieldwrapper.email',

                    '.fieldwrapper.ethnicity',
                    '.fieldwrapper.ethnicity_mother',
                    '.fieldwrapper.origin_country_mother',
                    '.fieldwrapper.ethnicity_father',
                    '.fieldwrapper.origin_country_father',
                    '.fieldwrapper.source',
                    '.fieldwrapper.agree_donation',
                    '.fieldwrapper.keep_in_touch',

                    '.fieldwrapper.cp1_firstname',
                    '.fieldwrapper.cp1_lastname',
                    '.fieldwrapper.cp1_mobile',
                    '.fieldwrapper.cp1_email',
                    '.fieldwrapper.cp1_relationship',

                    '.fieldwrapper.cp2_firstname',
                    '.fieldwrapper.cp2_lastname',
                    '.fieldwrapper.cp2_mobile',
                    '.fieldwrapper.cp2_email',
                    '.fieldwrapper.cp2_relationship'
                ];

                var data = [],
                    elements = $(personalSelector.join(',')),
                    elementCount = elements.length;

                elements.each(function () {
                    var $this = $(this),
                        input = $this.find('input'),
                        textarea = $this.find('textarea'),
                        select = $this.find('select'),
                        label = $this.find('label'),
                        val;

                    if(input.length === 1){
                        if (input.attr('type') === 'checkbox') {
                            val = input.get(0).checked ? 'Yes' : 'No';
                        } else {
                            val = input.val();
                        }
                    } else if (input.attr('type') === 'radio') {
                        input = $this.find('input:checked');
                        val = $.trim(input.parent('label').contents().get(1).nodeValue);
                    } else {
                        if (select.length === 1) {
                            var opt = select.find('option:selected');
                            val = opt.attr('value') ? opt.text() : '-';
                        } else if (textarea.length === 1) {
                            val = textarea.val();
                        }
                    }

                    var labelVal = '';
                    var summaryLabel = input.data('summary-label');
                    if (summaryLabel) {
                        labelVal = summaryLabel;
                    } else {
                        try {
                            labelVal = label.contents().get(0).nodeValue;
                        } catch (e) {
                            // some labels are empty
                        }
                    }

                    try {
                        var summaryDecoratorBefore = input.data('summary-decorator-before') || select.data('summary-decorator-before');
                        if (summaryDecoratorBefore) {
                            data.push([
                                '<li class="summary-decorator summary-decorator__before">',
                                DKMS.Utils.escapeHtml(summaryDecoratorBefore),
                                '</li><li>&nbsp;</li>'
                            ].join(''));
                        }

                        data.push([
                            '<li>',
                            DKMS.Utils.escapeHtml(labelVal),
                            '</li>',
                            '<li>',
                            DKMS.Utils.escapeHtml(val) || '&nbsp;',
                            '</li>'
                        ].join(''));
                    } catch (e) {
                        // some labels are empty
                    }

                    if(!--elementCount){
                        $('.review .description:first ul').html(data.join(''));
                    }
                });

                $form.addClass('page2');
                $('body').addClass('page2');
                $('html, body').stop().animate({
                    scrollTop:0
                }, '300');
            } else {
                $('html, body').stop().animate({
                    scrollTop: DKMS.Utils.topOfFirstError()
                }, '500');
            }
        });

        $('.backBtn').on('click', function () {
            $('#regForm, body').removeClass('page2');
            $('html, body').stop().animate({
                scrollTop:0
            }, '300');
        });

        $('input[type="radio"]').on('change', function() {
            $(this).parsley().validate();
        });
    };

    return f;
})();

DKMS.Surveys = (function() {

    function reset(f) {
        if (f[0].type === 'radio' || f[0].type === 'checkbox') {
            f.prop('checked', false);
        } else {
            f.val('');
        }

        f.trigger('change');
    }

    function require(f) {
       if (f.is(':visible')) {
           f.attr('required', 'required');
       } else {
           f.removeAttr('required');
       }
    }

    var toggleCache = {};
    function findInputs(parent) {
        var key = parent.attr('class');
        if (!toggleCache[key]) {
            toggleCache[key] = parent.find('[name]');
        }

        return toggleCache[key];
    }

    function toggle(elem, show) {
        if (show === true && !elem.is(':visible')) {
            elem.show();
            findInputs(elem).each(function() {
                require($(this));
            });
        } else if (show === false && elem.is(':visible')) {
            elem.hide();
            findInputs(elem).each(function() {
                reset($(this));
                require($(this));
            });
        }

        return elem;
    }

    function initCovido() {
        var block1 = toggle($('.block-block1'), false),
            block2 = toggle($('.block-block2'), false),
            block3 = toggle($('.block-block3'), false),
            block4 = toggle($('.block-block4'), false),
            block_submit = toggle($('.submit-block'), false),
            c1_input = $('input#id_consent_participation'),
            c2_input = $('input#id_dataprotectionprivacy'),
            q1_input = $('input[name=q1_tested]'),
            q2 = $('.q2_throatswab').hide(),
            q2_input = $('input[name=q2_throatswab]'),
            q3 = $('.q3_month').hide(),
            q9_input = $('input[name=q9_attested]'),
            q10 = $('.q10_symptoms').hide(),
            q10_input = $('input[name=q10_symptoms]'),
            q18_input = $('input[name=q18_hospital]'),
            q19 = $('.q19_oxygen').hide(),
            q20 = $('.q20_artresp').hide()
        ;

        function toggle_symptoms(show) {
            for (var i=11;i<=17;i++) {
                var q = $('[class*=q'+i+'_]');
                toggle(q, show);
            }
        }

        function isYes(e) {
            return $(e).is(':checked') && $(e).val() === 'YES';
        }

        function consentAgreed() {
            return c1_input.is(':checked') && c2_input.is(':checked');
        }

        c1_input.on('change', function() {
            var show = consentAgreed();
            toggle(block1, show);
        }).trigger('change');

        c2_input.on('change', function() {
            var show = consentAgreed();
            toggle(block1, show);
        }).trigger('change');

        q1_input.on('change', function() {
            var show = isYes(this);
            toggle(q2, show);
            toggle(block_submit, consentAgreed() && !show);
        }).trigger('change');

        q2_input.on('change', function() {
            var show = isYes(this);
            toggle(block_submit, consentAgreed());
            toggle(q3, show);
            toggle(block2, show);
            toggle(block3, show);
            toggle_symptoms(false); // initially hide symptoms
        }).trigger('change');

        q9_input.on('change', function() {
            var show = isYes(this);
            toggle(q10, show);
        }).trigger('change');

        q10_input.on('change', function() {
            var show = isYes(this);
            toggle_symptoms(show);
            toggle(block4, show);
        }).trigger('change');

        q18_input.on('change', function() {
            var show = isYes(this);
            toggle(q19, show);
            toggle(q20, show);
        }).trigger('change');
    }

    $(function() {
        if ($('body').hasClass('variant-covido')) {
            initCovido();
        }

        $('.help-trigger').on('click', function() {
            $(this).prev('.help-description').addClass('visible');
            $(this).hide();
        });
    });
})();

(function() {

    function init() {
        new DKMS.Main();

        window.Parsley.addValidator('notEqualto', {
            requirementType: 'string',
            validateString: function(value, requirement) {
                // special cases
                if (requirement === '__firstname_lastname__') {
                    var a = $('#id_firstname').val() + $('#id_lastname').val(),
                        b = $('#id_alternate_firstname').val() + $('#id_alternate_lastname').val();
                    return a.toLowerCase() !== b.toLowerCase();
                }

                // list of fields
                var isValid = true;
                var referenceFields = requirement.split(',');
                $(referenceFields).each(function(idx, req) {
                    var referenceField,
                        referenceValue;
                    if (req.indexOf('#') !== 0) {
                        referenceField = $('[name=' + req + ']');
                    } else {
                        referenceField = $(req);
                    }

                    referenceValue = requirement;
                    if (referenceField.length) {
                        referenceValue = referenceField.val();
                    }

                    isValid &= String(referenceValue).toLowerCase() !== String(value).toLowerCase();
                });

                return !!isValid;
            }
        });

        window.parsley.addValidator('restrictEmail', {
            requirementType: 'string',
            validateString: function(value, requirement) {
                return value.indexOf(requirement) === -1;
            },
            messages: {
                en: 'No valid e-mail address'
            }
        });

        window.parsley.addValidator('bmi', {
            requirementType: 'string',
            validateString: function(value, requirement) {
                var height, weight;
                if (requirement === 'height') {
                    height = parseFloat(value);
                    weight = parseFloat($('#id_weight').val());
                } else {
                    height = parseFloat($('#id_height').val());
                    weight = parseFloat(value);
                }

                height = height / 100;

                return (weight / (height * height)) < 40.0;
            },
            messages: {
                en: 'Your BMI needs to be below 40'
            }
        });

        window.parsley.addValidator('commonTld', {
            requirementType: 'string',
            validateString: function(value) {
                try {
                    var m = value.match(/.*\.([a-z]{2,})$/);
                    return DKMS.KNOWN_TLDS.indexOf(m[1]) > -1;
                } catch(e) {
                    return false;
                }
            },
            messages: {
                en: 'Unknown domain ending'
            }
        });

        window.parsley.addValidator('latin', {
            // validator not arabic chars from arabic unicode u0600-06ff.
            validateString: function(value) {
                return !(/[\u0600-\u06FF]/.test(value));
            },
            messages: {
                en: 'Invalid Characters',
                es: 'Caracteres inválidos',
                de: 'Ungültige Zeichen',
                pl: 'Nieprawidłowe znaki'
            }
        });

        window.Parsley.addValidator('requiredIf', {
            validateString : function(value, requirement) {
                var reqs = requirement.split(','),
                    reqFulfilled = function(requirement) {
                        var tmp = requirement.split(':'),
                            elem = $(tmp[0]),
                            mode = tmp.length > 1 ? tmp[1] : 'checked'; // legacy behavior

                        switch (mode) {
                        case 'checked':
                        case 'notchecked':
                            return elem.is(':checked') === (mode === 'checked');

                        case 'empty':
                        case 'notempty':
                            return !!($.trim(elem.val()).length) === !(mode === 'empty'); // empty = false == false

                        default:
                            // able to choose several possible options from a dropdown menu, separated by spaces
                            return mode.split(" ").indexOf(elem.val()) > -1;
                        }
                    };

                var doCheck = true;
                $(reqs).each(function(_i, onereq) {
                    doCheck &= reqFulfilled(onereq);
                });

                return doCheck ? (!!$.trim(value).length && value !== '-1') : true;
            },
            priority: 33,
            messages: {
                en: 'This value is required.'
            }
        });

        window.Parsley.addValidator('phonenumber', {
            requirementType: 'string',
            validateString: function(value, requirement) {
                value = value.replace(/^\+/, '00').replace(/[^\d]/g, '');

                function has_cc(v) {
                    v = v || value;
                    return !!v.match(/^00\d+/);
                }

                function has_local_cc(cc, v) {
                    v = v || value;
                    var re = new RegExp('^00'+cc+'\\d+');
                    return !!v.match(re);
                }

                function is_local(v) {
                    v = v || value;
                    return !!v.match(/^0[1-9]\d+/);
                }

                try {
                    switch (requirement) {
                    case 'GB':
                        return (
                            (has_local_cc(44) && value.length >= 13 && value.length <= 14) ||
                                (is_local() && value.length >= 10 && value.length <= 11) ||
                                (!has_local_cc(44) && has_cc()) ||
                                false
                        );

                    case 'US':
                        return /^\d{10,}$/.test(value);

                    case 'CL':
                        return /^[\d\s+]{9,}$/.test(value);

                    case 'IN':
                        return (
                            (has_local_cc(91) && value.length == 14) ||
                                value.length == 10 ||
                                (!has_local_cc(91) && has_cc()) ||
                                false
                        );
                    case 'ZA':
                        return (
                            (has_local_cc(27) && value.length <= 14 && value.length >= 13) ||
                            false
                        );
                    case 'PL':
                        return (
                            (has_local_cc(48) && value.length === 13 || value.length === 9) ||
                            false
                        );
                    }
                } catch(e) {
                    // we don't care
                }

                return false;
            },
            messages: {
                en: 'Invalid phone number',
                pl: 'Wpisz 9-cio cyfrowy numer telefonu'
            }
        });

        window.Parsley.addValidator('clRut', {
            validateString : function(value) {
                if (!/^[0-9]+-[0-9kK]{1}$/.test(value)) return false;

                function checksumValid(T) {
                    var M = 0,
                        S = 1;
                    for (; T; T = Math.floor(T / 10))
                        S = (S + T % 10 * (9 - M++ % 6)) % 11;
                    return S ? S - 1 : 'k';
                }

                var tmp = value.split('-');
                var digv = tmp[1];
                var rut = tmp[0];
                if (digv == 'K') digv = 'k';

                return (checksumValid(rut) == digv);
            },
            priority: 33,
            messages: {
                en: 'This RUT/RUN is invalid.'
            }
        });

        window.Parsley.addValidator('ageLimits', {
            validateString : function(value, requirement, instance) {
                var tmp = requirement.split('-'),
                    min_age = parseInt(tmp[0]),
                    max_age = parseInt(tmp[1]),
                    now = moment(),
                    fmt = instance.$element.data('pikaday-format') || Pikaday.i18n._momentLocale._longDateFormat.L,
                    bd = moment(value, fmt),
                    age_years = now.diff(bd, 'years', true);

                return age_years >= min_age && age_years <= max_age;
            },
            priority: 33,
            messages: {
                en: 'Not within age limits'
            }
        });

        window.Parsley.addValidator('iban', {
            validateString : function(value) {
                return IBAN.isValid(value);
            },
            priority: 33,
            messages: {
                en: 'This IBAN number seems to be invalid.'
            }
        });

        window.Parsley.addValidator('zaIdent', {
            validateString : function(value) {
                /*
                South africa uses an id with a checksum,
                this validator provides a check for the given
                number to show if it is valid
                */
                // https://www.westerncape.gov.za/general-publication/decoding-your-south-african-id-number-0
                var sum = 0;
                var numberOfDigits = value.length;
                var parity = numberOfDigits % 2;

                for (var idx = 0; idx < value.length; idx++) {
                    var digit = parseInt(value[idx]);
                    if (idx % 2 === parity) {
                        digit *= 2;
                    }

                    if (digit > 9) {
                        digit -= 9;
                    }

                    sum = sum + digit;
                }
                return sum % 10 === 0;
            },
            priority: 33,
            messages: {
                en: 'This identification is incorrect'
            }
        });
    }

    // do not use Sentry during local dev
    if (window.DKMS.DEBUG !== true) {
        Sentry.init({
            dsn: 'https://4d22ace42bef4a2884df268e3d058f48@sentry.services.dkms.org/2',
            debug: DKMS.DEBUG === true,
            release: DKMS.BUILD || '__undefined__',
            environment: DKMS.CONTEXT || '__undefined__',
            tags: {
                country: DKMS.COUNTRY_CODE
            },
            ignoreErrors: [
                // Random plugins/extensions
                'top.GLOBALS',
                // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
                'originalCreateNotification',
                'canvas.contentDocument',
                'MyApp_RemoveAllHighlights',
                'http://tt.epicplay.com',
                'Can\'t find variable: ZiteReader',
                'jigsaw is not defined',
                'ComboSearch is not defined',
                'http://loading.retry.widdit.com/',
                'atomicFindClose',
                // Facebook borked
                'fb_xd_fragment',
                // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
                // reduce this. (thanks @acdha)
                // See http://stackoverflow.com/questions/4113268
                'bmi_SafeAddOnload',
                'EBCallBackMessageReceived',
                // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
                'conduitPage',
                'fls.doubleclick.net',

                // DKMS included libs and known errors
                'androidInterface is not defined',
                'Blocked a frame with origin',
                'Can\'t find variable: twttr',
                'twttr is not defined'
            ],
            ignoreUrls: [
                // Facebook flakiness
                /graph\.facebook\.com/i,
                // Facebook blocked
                /connect\.facebook\.net\/en_US\/all\.js/i,
                // Woopra flakiness
                /eatdifferent\.com\.woopra-ns\.com/i,
                /static\.woopra\.com\/js\/woopra\.js/i,
                // Chrome extensions
                /extensions\//i,
                /^chrome:\/\//i,
                // Other plugins
                /127\.0\.0\.1:4001\/isrunning/i,  // Cacaoweb
                /webappstoolbarba\.texthelp\.com\//i,
                /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,

                // DKMS included libs
                /mathid\.mathtag\.com/i,
                /www\.paypalobjects\.com\/api\/checkout\.js/,
                /connect\.facebook\.net/,
                /kaspersky-labs\.com\/.*main\.js/,
                /cdn-widget\.callpage\.io/
            ]
        });
    }

    init();
}());
